import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { HubCardBaseSkeleton } from './hub-card-base-skeleton';
import { View } from 'react-native';

export const HubProfitRollupSectionSkeleton: React.FC = () => {
  const [styles] = useStyles();
  return (
    <HubCardBaseSkeleton
      actionsElement={
        <AnimatedSkeletonLoader
          height={36}
          style={styles.actionsElement}
          width="30%"
        />
      }
    >
      <View style={styles.container}>
        <View style={styles.content}>
          <AnimatedSkeletonLoader height={48} width={120} />
        </View>
        <View style={styles.content}>
          <AnimatedSkeletonLoader height={24} width={60} />
          <AnimatedSkeletonLoader height={24} width={60} />
        </View>
      </View>
    </HubCardBaseSkeleton>
  );
};

const useStyles = createStyles(() => ({
  actionsElement: {
    marginTop: 0, // override since HubCardBaseSkeleton sets marginTop to 4 to provide gaps between different skeleton elements
  },
  container: {
    gap: 4,
    justifyContent: 'center',
    marginVertical: 24,
    width: '100%',
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
}));
